import { Box, Flex, Spinner } from "@chakra-ui/react";

export default function LocalSpinner({ size = "xl", h = "full", w = "full", ...props }) {
  // overflow: hidden is to avoid the spinner from wobbling the size of the parent
  return (
    <Flex justifyContent="center" alignItems="center" height={h} width={w} overflow="hidden" {...props}>
      <Box maxW="100px" maxH="100px">
        <Spinner size={size} />
      </Box>
    </Flex>
  );
}
